import React, { useEffect, useState } from "react"
import axios from "axios"
import { Loading } from '../components/loading'
import { AppAssociationCard } from '../components/card'
import { AppCoopAssociationCard } from '../components/card/cooperating'
import { AppCoordinatorCard } from '../components/card/coordinator'
import { AppAmbAssocCard } from '../components/card/ambAssociation'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
// import Typography from '@material-ui/core/Typography';
// import Box from '@material-ui/core/Box';
import { TabPanel } from '../components/tab-panel'

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}))

export const HomePage = () => {
  const classes = useStyles()
  const [dataLoad, setdataLoad] = useState({
    loading:true,
    selectedAmbassador:'',
    selectedCountry:'',
    cardData:[],
    currentAssoc:null,
    dialogOpen:false,
    tabNumber:0,
    bilateralTab: {
      cardData:[]
    },
    ambassadorTab: {
      cardData:null
    },
    coordinatorTab: {
      cardData:null
    },
    ambassadorAssocTab: {
      cardData:[]
    }
  })

  const findUnique = c => {
    const nObj = []
    // console.log(c)
    c.forEach(item => {
      if(nObj.length == 0) {
        nObj.push(item)
      } else if(nObj[nObj.length - 1].field_2 != item.field_2) {
          nObj.push(item)
      }
    })

    return nObj
  }

  useEffect(() => {

    const getAmbassadors = axios.get(`/api/getAmbassadorList`)
    const getContries = axios.get(`/api/getCountryList`)
    const getCoopAssoc = axios.get(`/api/getList`)
    const getCoordinator = axios.get(`/api/getCoordinatorList`)
    const getAmbAssoc = axios.get(`/api/getAmbassadorAssocList`)
    const getLeadership = axios.get(`/api/getLeadershipList`)
    // const get
    Promise.all([getAmbassadors, getContries, getCoopAssoc,
      getCoordinator, getAmbAssoc, getLeadership]).then(values => {
      // console.log(values[1])
      setdataLoad({
        ...dataLoad,
        'ambassadors': values[0].data,
        'countries': findUnique(values[1].data),
        'coopAssoc': values[2].data,
        'coordinators': values[3].data,
        'ambassadorAssoc': values[4].data,
        'leadership': values[5].data,
        'loading': false
      })
    }).catch(e => console.error(e))
  }, [])

  const handleDialog = assoc => {
    const openClose = !dataLoad.dialogOpen
    setdataLoad({
      ...dataLoad,
      currentAssoc:assoc,
      dialogOpen:openClose
    })
  }

  const handleTabs = (event, newValue) => {
    setdataLoad({
      ...dataLoad,
      tabNumber:newValue
    })
  }

  const getAmbassador = ID => {
    return dataLoad.ambassadors.find(item => item.ID == ID)
  }

  const getPrimaryContact = ID => {
    return dataLoad.leadership.find(item => item.ID == ID)
  }

  const getCoordinator = ID => {
    const coord = dataLoad.coordinators.find(item => item.ID == ID)
    return coord ? coord : null
  }

  const getAmbassadorAssoc = ID => {
    return dataLoad.ambassadorAssoc.find(item => item.ID == ID)
  }

  const buildExtended = item => {
    return {...item,
      ["primaryContact"]: getPrimaryContact(item.Primary_x0020_ContactId),
      ["ambassador"]: getAmbassador(item.Global_x0020_AmbassadorId),
      ["coordinator"]: getCoordinator(item.GlobalCoordinatorId),
      ["ambassadorAssociation"]: getAmbassadorAssoc(item.AmbassadorAssociationId)
    }
  }

  const searchByAmbExt = ambassador => {
    let expandedList = getAmbassador(ambassador)
    const workswith = dataLoad.coopAssoc.filter(item => item.Global_x0020_AmbassadorId == ambassador)
    expandedList = {
      ...expandedList,
      ['worksWith']: workswith.map(item => (buildExtended(item)))
    }
    return expandedList
  }

  const searchByCoordExt = id => {
    let expandedList = getCoordinator(id)
    const workswith = dataLoad.coopAssoc.filter(item => item.GlobalCoordinatorId == id)
    expandedList = {
      ...expandedList,
      ['worksWith']: workswith.map(item => (buildExtended(item)))
    }
    return expandedList
  }

  const searchByAmbCountry = country => {
    const workswith = searchExtByCountry(country)
    let ambassador = null
    if(workswith.length > 0) {
      if(workswith[0].Global_x0020_AmbassadorId) {
        ambassador = getAmbassador(workswith[0].ambassador.ID)
        if(ambassador) {
          ambassador = {
            ...ambassador,
            ['worksWith']: workswith
          }
        }
      }
    }
    return ambassador
  }

  const searchByCoordCountry = country => {
    const workswith = searchExtByCountry(country)
    let coord = null
    if(workswith.length > 0) {
      if(workswith[0].GlobalCoordinatorId) {
        coord = getCoordinator(workswith[0].coordinator.ID)
        if(coord) {
          coord = {
            ...coord,
            ['worksWith']: workswith
          }
        }

      }
    }
    return coord
  }

  const searchByAssocCountry = country => {
    const workswith = searchExtByCountry(country)
    const assoc = []
    workswith.forEach((item, ix) => {
      if(ix == 0) {
        assoc.push({
          ...getAmbassadorAssoc(item.AmbassadorAssociationId),
          ['worksWith']: [item]
        })
      } else {
        const found = assoc.find(a => a.ID == item.AmbassadorAssociationId)
        if(found) {
          found.worksWith.push(item)
        } else {
          assoc.push({
            ...getAmbassadorAssoc(item.AmbassadorAssociationId),
            ['worksWith']: [item]
          })
        }
      }
    })
    return assoc
  }

  const searchByAssocAmb = ambAssoc => {
    const workswith = dataLoad.coopAssoc.filter(item => item.AmbassadorAssociationId == ambAssoc.ID)
    let assoc = ambAssoc
    assoc = {
      ...assoc,
      ['worksWith']: workswith.map(item => (buildExtended(item)))
    }
    return assoc
  }

  const searchExtByCountry = country => {
    const expandedList = dataLoad.coopAssoc.filter(item => item.field_2 == country)
    return expandedList.map(item => (buildExtended(item)))
  }

  const getExtended = item => {
    return [buildExtended(item)]
  }

  console.info(dataLoad)

  return (
    <div className="App-content">
      <div className="App-row">
        <h1>Global Alliances Directory</h1>
        <p>Find referral opportunities and business partnerships in over 77
          countries where NAR has established relationships.</p>
      </div>
      {dataLoad.loading ? (
                    <Loading />
                  ) : (
        <div className="App-row">
          <div className={classes.root}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={dataLoad.tabNumber}
          onChange={handleTabs}
          aria-label="Vertical tabs example"
          className={classes.tabs}>
          <Tab label="Bilateral Partners " {...a11yProps(0)} />
          <Tab label="Global Ambassadors" {...a11yProps(1)} />
          <Tab label="Global Coordinators" {...a11yProps(2)} />
          <Tab label="Ambassadors Associations" {...a11yProps(3)} />
        </Tabs>
        <TabPanel value={dataLoad.tabNumber} index={0}>
        <div className="App-w-100">
          <h4>Find a foreign bilateral partner in:</h4>
        </div>
      <div>
        <Autocomplete
        id="bilateral-combo-box-country"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            bilateralTab: {
              cardData:(newValue) ? searchExtByCountry(newValue?.field_2) : []
            }
          })
        }}
        options={dataLoad.countries}
        getOptionLabel={option => option.field_2}
        style={{ width: '99%' }}
        renderInput={params => <TextField
        {...params}
        label="Country"
        variant="outlined" />} />
      </div>
      <div className="App-w-100">
          <h4>Find a foreign bilateral partner by name:</h4>
        </div>
      <div>
        <Autocomplete
        id="bilateral-combo-box-name"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            bilateralTab: {
              cardData:(newValue) ? getExtended(newValue) : []
            }
          })
        }}
        options={dataLoad.coopAssoc}
        getOptionLabel={option => option.Title}
        style={{ width:  '99%'  }}
        renderInput={params => <TextField
        {...params}
        label="Cooperating Association"
        variant="outlined" />} />
      </div>
      <div className="App-w-100">
          <h4>Find a foreign bilateral partner by acronym:</h4>
        </div>
      <div className="App-mb-4">
        <Autocomplete
        id="bilateral-combo-box-acronym"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            bilateralTab: {
              cardData:(newValue) ? getExtended(newValue) : []
            }
          })
        }}
        options={dataLoad.coopAssoc}
        getOptionLabel={option => option.field_1}
        style={{ width:  '99%'  }}
        renderInput={params => <TextField
        {...params}
        label="Acronym"
        variant="outlined" />} />
      </div>
      {dataLoad.bilateralTab.cardData.map(item => (
          <div key={item.ID} className="App-mb-4">
            <AppCoopAssociationCard associationData={item} />
          </div>
        ))}
        </TabPanel>
        <TabPanel value={dataLoad.tabNumber} index={1}>
          <div className="App-w-100">
          <h4>Find a global ambassador by name:</h4>
        </div>
        <div>
        <Autocomplete
        id="combo-box-country"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            ambassadorTab: {
              cardData:(newValue) ? searchByAmbExt(newValue.ID) : null
            }
          })
        }}
        options={dataLoad.ambassadors}
        getOptionLabel={option => option.Full_x0020_Name}
        style={{ width: '99%' }}
        renderInput={params => <TextField
        {...params}
        label="Ambassador"
        variant="outlined" />} />
      </div>
      <div className="App-w-100">
          <h4>Find a global ambassador by country:</h4>
        </div>
      <div className="App-mb-4">
        <Autocomplete
        id="combo-box-country"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            ambassadorTab: {
              cardData:(newValue) ? searchByAmbCountry(newValue?.field_2) : null
            }
          })
        }}
        options={dataLoad.countries}
        getOptionLabel={option => option.field_2}
        style={{ width: '99%' }}
        renderInput={params => <TextField
        {...params}
        label="Country"
        variant="outlined" />} />
      </div>
      { (dataLoad.ambassadorTab.cardData) ? (
      <AppAssociationCard
      ambassadorData={dataLoad.ambassadorTab.cardData}
      currentAssoc={dataLoad.currentAssoc}
      handleDialog={handleDialog}
      dialogOpen={dataLoad.dialogOpen} />
      ) : (<br />) }
        </TabPanel>
        <TabPanel value={dataLoad.tabNumber} index={2}>
        <div className="App-w-100">
          <h4>Find a global coordinator by name:</h4>
        </div>
      <div>
        <Autocomplete
        id="coordinator-combo-box-name"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            coordinatorTab: {
              cardData:(newValue) ? searchByCoordExt(newValue.ID) : null
            }
          })
        }}
        options={dataLoad.coordinators}
        getOptionLabel={option => option.Title}
        style={{ width: '99%' }}
        renderInput={params => <TextField
        {...params}
        label="Name"
        variant="outlined" />} />
      </div>
      <div className="App-w-100">
          <h4>Find a global coordinator by country:</h4>
        </div>
      <div className="App-mb-4">
        <Autocomplete
        id="coordinator-combo-box-country"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            coordinatorTab: {
              cardData:(newValue) ? searchByCoordCountry(newValue?.field_2) : null
            }
          })
        }}
        options={dataLoad.countries}
        getOptionLabel={option => option.field_2}
        style={{ width: '99%' }}
        renderInput={params => <TextField
        {...params}
        label="Country"
        variant="outlined" />} />
      </div>
      { (dataLoad.coordinatorTab.cardData) ? (
      <AppCoordinatorCard
      coordinatorData={dataLoad.coordinatorTab.cardData}
      currentAssoc={dataLoad.currentAssoc}
      handleDialog={handleDialog}
      dialogOpen={dataLoad.dialogOpen} />
      ) : (<br />) }
        </TabPanel>
        <TabPanel value={dataLoad.tabNumber} index={3}>
        <div className="App-w-100">
          <h4>Find an ambassador association for:</h4>
        </div>
      <div>
        <Autocomplete
        id="ambassadorAssoc-combo-box-country"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            ambassadorAssocTab: {
              cardData: (newValue) ? searchByAssocCountry(newValue?.field_2) : null
            }
          })
        }}
        options={dataLoad.countries}
        getOptionLabel={option => option.field_2}
        style={{ width: '99%' }}
        renderInput={params => <TextField
        {...params}
        label="Country"
        variant="outlined" />} />
      </div>
      <div className="App-w-100">
          <h4>Find an ambassador association by name:</h4>
        </div>
      <div>
        <Autocomplete
        id="ambassadorAssoc-combo-box-name"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            ambassadorAssocTab: {
              cardData: (newValue) ? [searchByAssocAmb(newValue)] : null
            }
          })
        }}
        options={dataLoad.ambassadorAssoc}
        getOptionLabel={option => option.Title}
        style={{ width: '99%' }}
        renderInput={params => <TextField
        {...params}
        label="Name"
        variant="outlined" />} />
      </div>
      <div className="App-w-100">
          <h4>Find an ambassador association by Acronym:</h4>
        </div>
      <div className="App-mb-4">
        <Autocomplete
        id="ambassadorAssoc-combo-box-Acronym"
        onChange={(event, newValue) => {
          setdataLoad({
            ...dataLoad,
            ambassadorAssocTab: {
              cardData:(newValue) ? [searchByAssocAmb(newValue)] : null
            }
          })
        }}
        options={dataLoad.ambassadorAssoc}
        getOptionLabel={option => option.Acronym}
        style={{ width: '99%' }}
        renderInput={params => <TextField
        {...params}
        label="Acronym"
        variant="outlined" />} />
      </div>
      {dataLoad.ambassadorAssocTab.cardData?.map(item => (
          <div key={item.ID} className="App-mb-4">
            <AppAmbAssocCard
            associationData={item}
            currentAssoc={dataLoad.currentAssoc}
            handleDialog={handleDialog}
            dialogOpen={dataLoad.dialogOpen} />
          </div>
        ))}
        </TabPanel>
      </div>
      </div>
      )
    }
    </div>
  )
}
